import React, {useMemo, useState} from 'react';
import styled from 'styled-components';
import Input from '../../UI/Input';
import {fontSize, LoginBtn} from '../../mixins';
import {useDispatch} from 'react-redux';
import {sendLoginRequest, sendPassResetRequest} from './authSlice';
import {Show, Hide} from './Icons';
import {setError} from '../error/errorSlice';


const StyledContainer = styled.div`
  width: 100%;
  height: 30%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const StyledPassContainer = styled.div`
  position: relative;
  min-height: 85px;
`

const StyledForgotBtn = styled.button`
  font-weight: 300;
  ${fontSize(16)};
  line-height: 22px;
  text-align: right;
  color: #0D9477;
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
  
  &:focus {
    outline: none;
  }
`

const StyledShowBtn = styled.button`
  background-color: transparent;
  border: none;
  width: 35px;
  height: 35px;
  position: absolute;
  top: 47%;
  right: 8px;
`

const StyledLoginBtn = styled.button`
  ${LoginBtn};
`

const Email = () => {
    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');
    const [passType, setPassType] = useState('password');

    const onLoginClick = () => {
        if (email && pass) {
            return dispatch(sendLoginRequest({email, pass}));
        }
        dispatch(setError({show: true, type: 'login', text: 'Please select your login method'}));
    }

    const onForgotPassClick = () => {
        if (!email) {
            return dispatch(setError({show: true, type: 'reset pass', text: 'Please enter your email address'}));
        }
        dispatch(sendPassResetRequest(email));
    }


    const ShowPassIcon = useMemo(() => {
        if (pass) {
            if (passType === 'text') {
                return Hide;
            }

            return Show;
        }

        return null;

    }, [passType, pass]);

    const onShowPass = () => {
        if (passType === 'password') {
            return setPassType('text');
        }

        setPassType('password')
    };

    return (
        <>
            <StyledContainer>
                <Input tabIndex={1} label='Email' type='email' placeholder='name@mail.com' value={email}
                       onChange={(evt) => setEmail(evt.target.value)}/>
                <StyledPassContainer>
                    <StyledForgotBtn onClick={onForgotPassClick} id='continue-button'>Forgot your password?</StyledForgotBtn>
                    <StyledShowBtn onClick={onShowPass} id='continue-button'>{ShowPassIcon}</StyledShowBtn>
                    <Input tabIndex={1} label='Password' type={passType} placeholder='your password' value={pass}
                           onChange={(evt) => setPass(evt.target.value)}/>
                </StyledPassContainer>
            </StyledContainer>
            <StyledLoginBtn onClick={onLoginClick} id='continue-button'>Log in</StyledLoginBtn>
        </>


    )
};


export default Email;